import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=3b9f39a1&scoped=true"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=3b9f39a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f39a1",
  null
  
)

export default component.exports